import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Box, IconButton, TablePagination, Typography } from '@mui/material';

const CustomTablePaginationActions = ({
  page,
  onPageChange,
  count,
  rowsPerPage,
  isLoading,
}) => {
  const handleBackButtonClick = () => {
    onPageChange(null, page - 1);
  };

  const handleNextButtonClick = () => {
    onPageChange(null, page + 1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}>
      <IconButton
        size="small"
        onClick={handleBackButtonClick}
        disabled={page === 0 || !!isLoading}>
        <KeyboardArrowLeft />
      </IconButton>
      <Typography
        sx={{
          padding: 1,
          minWidth: 34,
          maxWidth: 34,
          textAlign: 'center',
        }}>
        {page + 1}
      </Typography>
      <IconButton
        size="small"
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1 || !!isLoading}>
        <KeyboardArrowRight />
      </IconButton>
    </Box>
  );
};

export const Pagination = ({
  page = 0,
  setPage,
  onChangePage,
  count = 0,
  isLoading = false,
  rowsPerPage = 10,
  rowsPerPageOptions = [10, 25, 50, 100],
  onRowsPerPageChange,
}) => {
  const handleChangePage = (_event, newPage) => {
    onChangePage(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    onRowsPerPageChange?.(event);
    onChangePage(0);
    setPage(0);
  };

  return (
    <TablePagination
      component="div"
      count={count}
      sx={{
        maxHeight: '52px',
        marginTop: 'auto',
        color: '#6F6B7D',
        '& .MuiToolbar-root': {
          display: 'grid',

          alignItems: 'center',
          gridTemplateColumns: '0 calc(50% - 51px) auto',
        },
        '& .MuiTablePagination-displayedRows': {
          margin: 0,
        },
      }}
      rowsPerPageOptions={[]}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      page={page}
      labelRowsPerPage=""
      labelDisplayedRows={({ from, to, count }) =>
        `${from} - ${to} de ${count}`
      }
      onPageChange={handleChangePage}
      // rowsPerPage={10}
      ActionsComponent={props => (
        <CustomTablePaginationActions
          page={page}
          isLoading={isLoading}
          {...props}
        />
      )}
    />
  );
};
